'use strict';

import $ from 'jquery';
import debounce from './debounce';

const dom = {};

const notification = {

  showElementsOnScroll: debounce(function() {
    const scrollTop = $(window).scrollTop();

    if(scrollTop > 0) {
      dom.$scrollNotifications.slideDown();

      $(document).off('scroll.notification', this.showElementsOnScroll);
    }
  }, 200),

  init: function() {
    dom.$scrollNotifications = $('[data-notification-parent][data-show-on-scroll]');

    $('[data-notification]').on('click', function() {
      const cookieName = this.dataset.notification;
      const year = window.location.pathname.split('/').filter(Boolean)[0];
      const expDate = new Date();
      expDate.setTime(expDate.getTime() + (7*24*60*60*1000)); // 1 week
      document.cookie = `${cookieName}=1;expires=${expDate.toUTCString()};path=/${year}/`;

      $(this).closest('[data-notification-parent]').slideUp(400, function() {
        $(this).remove();
      });

    });

    if(dom.$scrollNotifications.length) {
      $(document).on('scroll.notification', this.showElementsOnScroll);
    }
  }
}

module.exports = notification;
